// extracted by mini-css-extract-plugin
export var actionButton = "_8u-1";
export var actionButtons = "_8u-2";
export var actions = "_8u-0";
export var aiUnread = "_8u-10";
export var alignCenter = "_8u-h";
export var backWrapper = "_8u-3";
export var cellContainer = "_8u-4";
export var checkboxContainer = "_8u-5";
export var contentContainer = "_8u-6";
export var contentHeader = "_8u-8";
export var conversationsTableWrapper = "_8u-s";
export var draftReplyBadgeContainer = "_8u-m";
export var dropdownItem = "_8u-b";
export var dropdownItemsContainer = "_8u-a";
export var dropdownTitle = "_8u-c";
export var errorIcon = "_8u-7";
export var filter = "_8u-d";
export var gray = "_8u-i";
export var headerActionButtons = "_8u-e";
export var headerCheckboxContainer = "_8u-f";
export var icon = "_8u-j";
export var menuContainer = "_8u-k";
export var noMoreTicketsIcon = "_8u-12";
export var noMoreTicketsSubText = "_8u-13";
export var oneLine = "_8u-l";
export var optionsButton = "_8u-n";
export var plus = "_8u-o";
export var portalButtonsWrapper = "_8u-g";
export var red = "_8u-p";
export var scrolledTop = "_8u-9";
export var search = "_8u-q";
export var selectedConversationsCount = "_8u-r";
export var spinner = "_8u-t";
export var strong = "_8u-u";
export var summaryCell = "_8u-v";
export var tableContainer = "_8u-11";
export var tagContainer = "_8u-w";
export var threeDots = "_8u-x";
export var twoLines = "_8u-y";
export var unread = "_8u-z";